import { OptionService } from "@/service/OptionService";
import { ShinseiService } from "@/service/ShinseiService";
import { ShinseiOption } from "@/types/Option";
import { Ref, ref, computed } from "vue";

/*
 * 初期処理
 */
export function useInit() {
  const loading = ref(1); // APIで読み込みをする本数
  const isError = ref(false);


  // 申請メニュー一覧で必要なオプション類を取得する
  const srv = new ShinseiService();
  const options: Ref<ShinseiOption | null> = ref(null);
  srv.getShinseiOption().then(opt => {
    if (opt) {
      options.value = opt;
    } else {
      // エラー
      isError.value = true;
    }
    loading.value--;
  });

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  return {
    options,
    isLoading,
    isError,
  }
}
